import PropTypes from "prop-types";
import { Handle, Position } from "@xyflow/react";

/**
 * JunctionNode – Pipe intersection / splitter node.
 *
 * A small circle with 4 handles (top, bottom, left, right)
 * that acts as a pipe junction / manifold for connecting
 * multiple components together.
 *
 * Supports:
 * - Multiple connections (4 ports)
 * - Compact visual footprint
 * - Selection highlight
 */
const JunctionNode = ({ data, selected }) => {
  const color = data?.styles?.color || "#64748b";

  return (
    <div
      className={`live-node ${selected ? "live-node--selected" : ""}`}
      title={data?.title || "Junction"}
    >
      {/* Top handle */}
      <Handle
        type="source"
        position={Position.Top}
        id="top"
        isConnectable={!data?.readOnly}
        isConnectableStart={!data?.readOnly}
        isConnectableEnd={!data?.readOnly}
        className="live-node__handle"
      />

      {/* Left handle */}
      <Handle
        type="source"
        position={Position.Left}
        id="left"
        isConnectable={!data?.readOnly}
        isConnectableStart={!data?.readOnly}
        isConnectableEnd={!data?.readOnly}
        className="live-node__handle"
      />

      {/* Junction visual */}
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Outer ring */}
        <circle
          cx="12"
          cy="12"
          r="10"
          fill={`${color}20`}
          stroke={color}
          strokeWidth="2"
        />
        {/* Cross pattern */}
        <line x1="4" y1="12" x2="20" y2="12" stroke={color} strokeWidth="1.5" opacity="0.5" />
        <line x1="12" y1="4" x2="12" y2="20" stroke={color} strokeWidth="1.5" opacity="0.5" />
        {/* Center dot */}
        <circle cx="12" cy="12" r="3" fill={color} />
      </svg>

      {/* Right handle */}
      <Handle
        type="source"
        position={Position.Right}
        id="right"
        isConnectable={!data?.readOnly}
        isConnectableStart={!data?.readOnly}
        isConnectableEnd={!data?.readOnly}
        className="live-node__handle"
      />

      {/* Bottom handle */}
      <Handle
        type="source"
        position={Position.Bottom}
        id="bottom"
        isConnectable={!data?.readOnly}
        isConnectableStart={!data?.readOnly}
        isConnectableEnd={!data?.readOnly}
        className="live-node__handle"
      />
    </div>
  );
};

JunctionNode.propTypes = {
  data: PropTypes.object,
  selected: PropTypes.bool,
  id: PropTypes.string,
};

export default JunctionNode;
